import { ILEGGELSE_SERVICE_BASE_URL } from "../config.ts";

export const GET_FOLGEBREV_URL = `${ILEGGELSE_SERVICE_BASE_URL}/folgebrev`;
